import moment from "moment"
import { FeedbackBranch } from "../models/feedback-store"

export const formatFileSize = (size: number) => {
  if (size < 1024) {
    return `${size} Б`
  }

  if (size < 1024 * 1024) {
    return `${Math.round(size / 1024)} КБ`
  }

  return `${(size / 1024 / 1024).toFixed(1)} МБ`
}

export const formatDateTime = (value: string | null) => (value ? moment(value).format("DD.MM.YYYY HH:mm") : "")

/** Сегодня — только время, иначе дата */
export const formatShortDate = (value: string | null) => {
  if (!value) {
    return ""
  }

  const date = moment(value)
  return date.isSame(moment(), "day") ? date.format("HH:mm") : date.format("DD.MM.YY")
}

/** «Петров Пётр Петрович» → «Петров П. П.» */
export const shortName = (name: string | null) => {
  const parts = (name || "").split(" ").filter((p) => !!p)

  if (parts.length < 2) {
    return parts.join("")
  }

  return `${parts[0]} ${parts
    .slice(1)
    .map((p) => `${p[0].toUpperCase()}.`)
    .join(" ")}`
}

export const MY_BRANCH_TITLE = "Мои обращения"

/** Личная ветка сотрудника — в том числе админа */
export const isOwnBranch = (branch: FeedbackBranch | null, userId: string) =>
  !!branch && branch.kind === "employee" && branch.subjectExternalId === userId

/** branch = null — личной ветки ещё нет: первое сообщение без branchId заведёт её */
export const branchTitle = (branch: FeedbackBranch | null, userId: string) => {
  if (!branch || isOwnBranch(branch, userId)) {
    return MY_BRANCH_TITLE
  }

  return branch.kind === "admins" ? "Чат администраторов" : branch.subjectName || "Сотрудник"
}
